import $ from 'jquery';
import AppComponent from './app_component';

export default class Page extends AppComponent {
    componentDidMount() {
        super.componentDidMount();
        $(window).scrollTop(0);
    }
}
